import { render, staticRenderFns } from "./DiscountDialogForm.vue?vue&type=template&id=28a5ea90&"
import script from "./DiscountDialogForm.vue?vue&type=script&lang=js&"
export * from "./DiscountDialogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports